import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

export default function AppShellToolbar({ onBack, label = 'Volver', trailing = null }) {
  return (
    <div className="app-shell-toolbar">
      <button type="button" className="apps-btn apps-btn-ghost apps-btn-sm" onClick={onBack}>
        <ArrowBackRoundedIcon style={{ fontSize: 16 }} />
        {label}
      </button>
      {trailing ? <div className="app-shell-toolbar__trailing">{trailing}</div> : null}
    </div>
  );
}
